
import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type { MediaType, MediaPayloadType } from "@/common/types/media";

export async function mediaList(
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `media/list${queryString}`
    );
}

export async function mediaGet(
    media_id: string
) {
    return await clientAxios.get(
        `media/${media_id}/show`
    );
}

export async function mediaAdd(
    payload: MediaPayloadType
) {
    return await clientAxios.post(
        `media/create`,
        payload
    );
}

export async function mediaPatch(
    media_id: string,
    payload: Partial<MediaType>
) {
    return await clientAxios.patch(
        `media/${media_id}/patch`,
        { payload }
    );
}

export async function mediaDel(
    media_id: string,
) {
    return await clientAxios.del(
        `media/${media_id}/delete`,
    );
}
